// One-line address for tables and quick search, e.g. "123 Main St, Toronto, ON, M5V 1A1, Canada".
// An address picked with Google Places autocomplete is saved whole in the street field (it always has
// commas - "123 Main St, Toronto, ON M5V 1A1, Canada") with city, province, etc. also stored separately,
// so that's used as-is. A street-only value (e.g. from an import) gets the other parts added after it.
export function FormatAddress(street: any, ...otherParts: any[]): string {
  const clean = (part: any) => (part === null || part === undefined) ? '' : String(part).trim();
  const streetText = clean(street);
  if (streetText.includes(',')) return streetText;
  return [streetText, ...otherParts.map(clean)].filter(part => part !== '').join(', ');
}

// Mailing label lines, e.g. ["6 Aurora Cres", "Nepean Ontario", "K2G 0Z7"]. The country only gets its own line
// when it isn't Canada (a domestic label leaves it off). A Google Places street value holds the whole address
// ("6 Aurora Cres, Nepean, ON K2G 0Z7, Canada"), so when the city / province / postal code are stored separately
// only the part before the first comma is the street line. With none of them stored, the street value is all
// there is, so each comma-separated part gets its own line instead.
export function MailingLabelLines(street: any, city: any, province: any, postal_code: any, country: any): string[] {
  const clean = (part: any) => (part === null || part === undefined) ? '' : String(part).trim();
  const streetText = clean(street);
  const cityText = clean(city), provinceText = clean(province), postalText = clean(postal_code), countryText = clean(country);
  const hasParts = !!(cityText || provinceText || postalText);
  if (!hasParts && streetText.includes(',')) {
    return streetText.split(',').map(part => part.trim()).filter(part => part !== '');
  }
  const lines = [
    hasParts && streetText.includes(',') ? streetText.split(',')[0].trim() : streetText,
    [cityText, provinceText].filter(part => part !== '').join(' '),
    postalText,
    /^(canada|ca)$/i.test(countryText) ? '' : countryText,
  ];
  return lines.filter(line => line !== '');
}

// Google Maps search link for an address ('' when there's no address to look up).
export function GoogleMapsUrl(address: string): string {
  return address ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}` : '';
}
